<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick } from "vue";
import { Globals } from "@/Globals";
import { globalsBezeichnung, begriffBezeichnung } from "@/local";
import { getKennungValueDisplay, getKennungTitle, getKZValueDisplay } from "@/DataHelper";
import CommonVCardDialog from "@/components/common/VCardDialog.vue";
import DialogAntrag from "@/views/PZE/persoenlich/Planungen/Templates/DialogAntrag.vue";
import { getSiteData } from "@/NavigationHelper";
import { mountedBase, onSave, BaseSetup } from "@/DataLoaderStatic";
import { goBack } from "@/NavigationHelper";
const emit = defineEmits(["back"]);
const siteData = getSiteData();
let soll = ref<string>("");
let ist = ref<string>("");
let saldo = ref<string>("");
let differenz = ref<string>("");
let pause = ref<string>("");
let verfallBeginn = ref<string>("");
let verfallEnde = ref<string>("");
let day = ref<string>(siteData?.zeitbereich.von.toLocaleDateString() ?? new Date());
let name = ref<string>("");
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "PZE_Web_TagesSalden",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data!) {
    soll.value = getKennungValueDisplay(uiData.data[0], "Soll", uiData.columns);

    ist.value = getKennungValueDisplay(uiData.data[0], "Ist", uiData.columns);
    pause.value = getKennungValueDisplay(uiData.data[0], "Pause", uiData.columns);
    saldo.value = getKennungValueDisplay(uiData.data[0], "Saldo", uiData.columns);
    name.value = getKZValueDisplay(uiData.data[0], "name", uiData.columns);
    differenz.value = getKennungValueDisplay(uiData.data[0], "Differenz", uiData.columns);
    verfallBeginn.value = getKennungValueDisplay(
      uiData.data[0],
      "VerfallzeitBeginn",
      uiData.columns
    );
    verfallEnde.value = getKennungValueDisplay(
      uiData.data[0],
      "VerfallzeitEnde",
      uiData.columns
    );
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
</script>
<template id="editorTemplate">
  <v-card :loading="uiData.showLoading" class="pa-0">
    <v-toolbar
      class="subtitle-1 dvhBackground lighten-2"
      v-if="uiData.initialized"
      style="color: white"
    >
      <span style="color: white" class="pr-2 pl-1">
        {{ globalsBezeichnung(Globals.Begriff, "Web_SW_Detailantrag", "Detailantrag") }}:
      </span>
      <span class="white--text"> {{ name }}: {{ day }}</span>
      <v-spacer></v-spacer>
      <v-divider class="px-2" vertical></v-divider>

      <v-btn @click="goBack()" icon="mdi-close"> </v-btn>
    </v-toolbar>

    <v-card-text class="ma-2 pa-2" min-width="450px">
      <v-row>
        <v-col cols="12" xs="12" sm="6">
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungTitle("Soll", uiData.columns)
              }}</span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{ soll }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungTitle("Ist", uiData.columns)
              }}</span>
            </v-col>
            <v-col class="dvhCol">
              <div>{{ ist }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungTitle("Differenz", uiData.columns)
              }}</span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{ differenz }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungTitle("Saldo", uiData.columns)
              }}</span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{ saldo }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xs="12" sm="6">
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungTitle("Pause", uiData.columns)
              }}</span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{ pause }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungTitle("VerfallzeitBeginn", uiData.columns)
              }}</span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{ verfallBeginn }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungTitle("VerfallzeitEnde", uiData.columns)
              }}</span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{ verfallEnde }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>

    <CommonVCardDialog
      textQuery="ZE_Gesamtsaldo_Neu"
      :text="globalsBezeichnung(Globals.Begriff, 'Web_Gesamtsaldo', 'akt. Gesamtsaldo')"
      textKennung="BERECHNUNG_MASS"
      :zeitbereich="siteData?.zeitbereich"
      :aic="pageParams.aic"
    ></CommonVCardDialog>
    <DialogAntrag
      v-if="uiData.initialized && siteData?.zeitbereich != 0"
      @back="goBack()"
      :zeitbereichUebergabe="siteData?.zeitbereich"
      :showClose="true"
    ></DialogAntrag>
  </v-card>
</template>

<style scoped>
.v-card {
  height: auto;
  width: 100%;
  margin: 0px;
  padding: 0px;
  display: inline-block;
  vertical-align: top-left;
}
.dvhCard {
  margin-bottom: 0px;
  width: 100%;
  padding-top: 0px;
  padding-left: 5px;
  padding-right: 5px;
  /* overflow-y: scroll; */
}
.dvhCol {
  padding-right: 0px;
  padding-left: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.cardText {
  margin-bottom: 5px;
  margin-top: 5px;
  text-align: left;
  padding: 10px;
}
@media (max-width: 550px) {
  .v-card__subtitle,
  .v-card__text,
  .v-card__title {
    padding: 10px;
  }
}
.white--text {
  color: white;
}
</style>
